import i18n from '@shared/i18n';
import { PLAN_LOCK_FEATURE, PLAN_TYPE } from './constants';

export const localizedPlanTypeNameMap = {
    [PLAN_TYPE.STARTER]: i18n.gettext('入門 Starter'),
    [PLAN_TYPE.BASIC]: i18n.gettext('基礎 Basic'),
    [PLAN_TYPE.STANDARD]: i18n.gettext('標準 Standard'),
    [PLAN_TYPE.ADVANCED]: i18n.gettext('進階 Advanced'),
};

export const planLevelMap = {
    [PLAN_TYPE.STARTER]: 1,
    [PLAN_TYPE.BASIC]: 2,
    [PLAN_TYPE.STANDARD]: 3,
    [PLAN_TYPE.ADVANCED]: 4,
};

export const planRestrictionMap = {
    [PLAN_LOCK_FEATURE.CUSTOM_DOMAIN]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false, // 是否可用
            limit: null, // 限制數量
            checkLimit: false, // 是否檢查限制數量
            visible: true, // 是否顯示相關提示在 UI 上
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
    },
    [PLAN_LOCK_FEATURE.CUSTOM_URL_SLUG]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
    },
    [PLAN_LOCK_FEATURE.CUSTOM_META_TAGS]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
    },
    [PLAN_LOCK_FEATURE.CUSTOM_PAGE]: {
        [PLAN_TYPE.STARTER]: {
            enabled: true,
            limit: 1,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: 5,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: 15,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: 100,
            checkLimit: true,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.DELAYED_LISTING]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.DELAYED_SALE]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.STOCK_THRESHOLD]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
    },
    [PLAN_LOCK_FEATURE.PRIVATE_PRODUCT]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
    },
    [PLAN_LOCK_FEATURE.PRODUCT_DESCRIPTION]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: 3,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.BATCH_UPDATE_PRODUCT]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.ORDER_TAG]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.ORDER_SHIPPING_TICKET]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.ORDER_PICKUP_TICKET]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.ORDER_EXPORT_CSV]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.INVOICE]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.COUPON]: {
        [PLAN_TYPE.STARTER]: {
            enabled: true,
            limit: 3,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.PROMO]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: 15,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.PROMO_DATETIME]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: true,
        },
    },
    [PLAN_LOCK_FEATURE.GIVEAWAY]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.PROMO_AUTO_DISTRIBUTE]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.ACCOUNT_COUNT]: {
        [PLAN_TYPE.STARTER]: {
            enabled: true,
            limit: 1,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: 2,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: 5,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: 20,
            checkLimit: true,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.MEDIA_UPLOAD_COUNT]: {
        [PLAN_TYPE.STARTER]: {
            enabled: true,
            limit: 100,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: 100,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: 100,
            checkLimit: true,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: 100,
            checkLimit: true,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.COMPONENT_SEARCH_BAR]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
    [PLAN_LOCK_FEATURE.COMPONENT_TYPING_SUGGESTION]: {
        [PLAN_TYPE.STARTER]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.BASIC]: {
            enabled: false,
            limit: null,
            checkLimit: false,
            visible: true,
        },
        [PLAN_TYPE.STANDARD]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
        [PLAN_TYPE.ADVANCED]: {
            enabled: true,
            limit: null,
            checkLimit: false,
            visible: false,
        },
    },
} as Record<
    PLAN_LOCK_FEATURE,
    Record<
        PLAN_TYPE,
        {
            enabled: boolean;
            limit: number | null;
            checkLimit: boolean;
            visible: boolean;
        }
    >
>;

export const upgradePromptMap = {
    [PLAN_LOCK_FEATURE.CUSTOM_PAGE]: i18n.gettext(
        '客製化頁面已達 {plan_type} 的使用上限。你可以<span>升級方案</span>以使用更多'
    ),
    [PLAN_LOCK_FEATURE.MEDIA_UPLOAD_COUNT]: i18n.gettext(
        '商店的圖片容量已達上限（{count} 張）！你可以<span>升級方案</span>以使用更多'
    ),
    [PLAN_LOCK_FEATURE.COUPON]: i18n.gettext(
        '優惠券已達上限 {plan_type} 的使用上限（{count} 張）。你可以<span>升級方案</span>以使用更多'
    ),
    [PLAN_LOCK_FEATURE.DELAYED_LISTING]: i18n.gettext(
        '你可以<span>升級方案</span>使用商品排程，幫助你自動化管理販售時間'
    ),
    [PLAN_LOCK_FEATURE.DELAYED_SALE]: i18n.gettext(
        '你可以<span>升級方案</span>使用商品排程，讓商品介紹管理更便利！'
    ),
    [PLAN_LOCK_FEATURE.STOCK_THRESHOLD]: i18n.gettext(
        '你可以<span>升級方案</span>使用庫存預警功能，讓商品介紹管理更便利！'
    ),
    [PLAN_LOCK_FEATURE.PRIVATE_PRODUCT]: i18n.gettext(
        '你可以<span>升級方案</span>使用隱藏商品，讓客人只能透過你分享網址進入'
    ),
    [PLAN_LOCK_FEATURE.PRODUCT_DESCRIPTION]: i18n.gettext(
        '你可以<span>升級方案</span>使用或擴充商品描述設定功能，讓商品介紹管理更便利！'
    ),
    [PLAN_LOCK_FEATURE.BATCH_UPDATE_PRODUCT]: i18n.gettext(
        '你可以<span>升級方案</span>使用商品的批次編輯，提高營運效率'
    ),
    [PLAN_LOCK_FEATURE.ORDER_TAG]: i18n.gettext(
        '你可以<span>升級方案</span>使用編輯訂單標籤功能，幫助品牌辨識多筆訂單！'
    ),
    [PLAN_LOCK_FEATURE.ORDER_PICKUP_TICKET]: i18n.gettext(
        '你可以<span>升級方案</span>使用列印揀貨單功能，幫助品牌大量操作訂單作業！'
    ),
    [PLAN_LOCK_FEATURE.ORDER_EXPORT_CSV]: i18n.gettext(
        '你可以<span>升級方案</span>使用批次匯出 CSV 功能，幫助品牌大量操作訂單作業！'
    ),
    [PLAN_LOCK_FEATURE.PROMO]: i18n.gettext(
        '你可以<span>升級方案</span>解鎖無限制的優惠券設定！'
    ),
    [PLAN_LOCK_FEATURE.ACCOUNT_COUNT]: i18n.gettext(
        '管理員帳號數已達上限！你可以<span>升級方案</span>解鎖更多的使用數量！'
    ),
    [PLAN_LOCK_FEATURE.COMPONENT_SEARCH_BAR]: i18n.gettext(
        '你可以<span>升級方案</span>解鎖 AI 智慧站內搜尋引擎！'
    ),
} as Record<PLAN_LOCK_FEATURE, string>;

export function checkPlanRestriction(
    planType: PLAN_TYPE,
    feature: PLAN_LOCK_FEATURE,
    currentLimit?: number | null
) {
    const plan = planRestrictionMap[feature][planType];

    let overLimit = false;

    if (!plan) {
        return {
            feature,
            enabled: false,
            visible: false,
            overLimit: false,
            detail: {
                enabled: false,
                limit: null,
                checkLimit: false,
                visible: false,
            },
        };
    }

    if (plan.limit === null) {
        overLimit = false;
    } else if (typeof currentLimit === 'number' && plan.checkLimit) {
        overLimit = plan.limit === null ? false : currentLimit >= (plan.limit ?? 0);
    }

    const result = {
        feature,
        enabled: plan.enabled,
        visible: plan.visible,
        overLimit,
        detail: plan,
    };

    return result;
}

export function getFeatureByApiEndpoint(url?: string) {
    if (!url) {
        return '';
    }

    const uploadURL = url.match(/(.*)\/upload-url/);

    const invitation = url.match(/(.*)\/invitation/);

    const coupon = url.match(/(.*)\/promo\/coupon/);

    const batchUpdate = url.match(/(.*)\/batch-update/);

    if (uploadURL) {
        return PLAN_LOCK_FEATURE.MEDIA_UPLOAD_COUNT;
    }

    if (invitation) {
        return PLAN_LOCK_FEATURE.ACCOUNT_COUNT;
    }

    if (coupon) {
        return PLAN_LOCK_FEATURE.COUPON;
    }

    if (batchUpdate) {
        return PLAN_LOCK_FEATURE.BATCH_UPDATE_PRODUCT;
    }

    return '';
}

export function getUpgradePrompt(plan: PLAN_TYPE, feature?: PLAN_LOCK_FEATURE) {
    if (!feature || !plan) {
        return '';
    }

    let prompt = upgradePromptMap[feature];

    if (!prompt) {
        return '';
    }

    const count = planRestrictionMap[feature]?.[plan]?.limit;

    const planType = localizedPlanTypeNameMap[plan];

    prompt = prompt.replace('{plan_type}', planType);

    if (count) {
        prompt = prompt.replace('{count}', String(count));
    }

    return prompt;
}

export function checkIsDowngrade(currentPlan: PLAN_TYPE, renewPlan: PLAN_TYPE) {
    return planLevelMap[currentPlan] > planLevelMap[renewPlan];
}
